import React from 'react';
import ajax from '../../ajax';
import functions from '../../functions';
import ActivityLoader from '../Common/ActivityLoader';
import $ from 'jquery';
import MdlLoanStatement from '../MdlLoanStatement';


class CustomerLoans extends React.Component {
  
  state={
    userId:functions.sessionGuard(),
    clientId:this.props.clientId,
    loanList:false,
    metaData:false,
    filter:"ALL",
    page:1,
    title:"All Loans",
    loanRecord:'',
    selectedLoanId:'',
    statement:false
  }


  componentDidMount()
  {
    this.listLoans();
  }


  listLoans=async()=>{
    switch(this.state.filter){
      case "ALL":
        var server_response=await ajax.filterAllLoans(this.state.clientId, this.state.page);
      break;
      case "BUSINESS":
        var server_response=await ajax.filterBusinessLoans(this.state.clientId, this.state.page);
      break;
      case "PERSONAL":
        var server_response=await ajax.filterPersonalLoans(this.state.clientId, this.state.page);
      break;
      case "DEFAULTED":
        var server_response=await ajax.filterDefaultedLoans(this.state.clientId, this.state.page);
      break;
      case "OUTSTANDING":
        var server_response=await ajax.filterOutstandingLoans(this.state.clientId, this.state.page);
      break;

    }
     // console.log(server_response.details)
      if(server_response.status==="OK")
      {
         this.setState({
            loanList:server_response.details.list,
            metaData:server_response.details.meta
         })

      }else{
        this.setState({
            loanList:"404"
        })
      }
  }


  onSelectRecord=(selectedLoanId)=>{
    this.setState({
        selectedLoanId})
    }

   //==============NAVIGATION CONTROLS START===========================
   onClickNext=()=>{
    //increment page numbers
    const metaData=this.state.metaData;
    if(metaData.current_page*1+1<=metaData.total_pages*1)
    {
      this.setState({
        page:this.state.page+1,
        loanList:false

      }, ()=>{
        this.listLoans();
      })
    }

  }

  onClickPage=(page)=>{
    this.setState({
        page:page,
        loanList:false
    }, ()=>this.listLoans())
}

  onClickPrevious=()=>{
    const metaData=this.state.metaData;
    if(metaData.current_page*1>1)
    {
      this.setState({
        page:this.state.page-1,
        loanList:false

      }, ()=>{
        this.listLoans();
      })
    }

  }

  //==============NAVIGATION CONTROLS END===========================



  onClickLoan=(record)=>{
    this.setState({
      statement:false
    }, ()=>{
      this.setState({
        statement:<MdlLoanStatement loan={record}/>
      }, ()=>{
        $("#modal_loan").modal('show');
      })
    })
  }


    
  render(){
    const list=this.state.loanList
    const metaData=this.state.metaData;
      return (
            
        <div className="">
           {this.state.statement}
            <div className="card custom-card">
                <div className="card-body">
                    <div>
                        <h6 className="card-title mb-1">Loan History</h6>
                        <p className="text-muted card-sub-title">List of all loans obtained by customer</p>
                    </div>
                    <div className="table-responsive scroll-widget overflow-auto">
                    <table className="table table-bordered text-nowrap mb-0">
                                <thead>
                                  <tr>
                                    <th>#No</th>
                                    <th>Loan Type</th>
                                    <th>Loan ID</th>
                                    <th>Loan Date</th>
                                    <th>Deadline</th>
                                    <th>Princ(UGX)</th>
                                    <th>Interest(UGX)</th>
                                    <th>Paid</th>
                                    <th>Fine</th>
                                    <th>Balance</th>
                                    <th>Agent Phone</th>
                                  </tr>
                                </thead>
                                <tbody>

                                {list && list!=="404" && list.map((item, key)=>
                                    <tr 
                                      key={key}  
                                      className={`${this.state.selectedLoanId==item.loan_id?'flag-row':''} hot-tr`}
                                      onClick={()=>this.onSelectRecord(item.loan_id)}>
                                    <td>{metaData.offset_count + key+1}</td>

                                    <td>
                                        {item.package_info.loan_type.type_name}
                                    </td>

                                    <td>
                                        <a 
                                          className="link" 
                                          onClick={()=>this.onClickLoan(item)}
                                            >
                                        {item.loan_code}
                                        </a> 
                        
                                    </td>
                                   
                                    <td>{item.loan_date.short_date}</td>
                                    <td>{item.deadline.short_date}</td>


                                    <td>{item.loan_principal.amount_c}</td>
                                    <td>{item.loan_interest.amount_c}</td>


                                    <td>{item.total_paid.amount_c}</td>
                                    <td>{item.loan_fine.amount_c}</td>
                                    <td>{item.loan_balance.amount_c}</td>
                                    <td>
                                        <a className="link">{item.agent_info.phone}</a>
                                    </td>
                                  </tr>
                                                          )}	
                                  
                                </tbody>
                              </table>





                        {this.state.metaData && <nav aria-label="Page navigation example">
                        <ul className="pagination justify-content-end">
                            <li className={`page-item ${this.state.currentPage===1 && "disabled"}`}>
                                <a 
                                    className="page-link" 
                                    href="#" tabindex="-1" 
                                    aria-disabled={this.state.currentPage===1?false:true}
                                    onClick={this.onClickPrevious}
                                    >Previous</a>
                            </li>

                            {this.state.metaData.list_of_pages.map((item, key)=>
                                <li className={`page-item ${this.state.currentPage===item && "active"}`} key={key}>
                                    <a 
                                        className="page-link" 
                                        href="#"
                                        onClick={()=>this.onClickPage(item)}>{item}</a>
                                </li>)}
                           
                            <li className={`page-item ${this.state.currentPage===this.state.metaData.total_pages && "disabled"}`}>
                                <a 
                                    className="page-link" 
                                    href="#"
                                    onClick={this.onClickNext}>Next</a>
                            </li>
                        </ul>
                    </nav>}

                    {!this.state.loanList && <ActivityLoader/>}




                    </div>
                </div>
            </div>
        </div>
      );
    
 
  }
}

export default CustomerLoans